module.exports = __webpack_public_path__ + "static/media/p1.28618d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p1.png
// module id = 955
// module chunks = 0